import { render, staticRenderFns } from "./classDetailY.vue?vue&type=template&id=b6443ff2&scoped=true"
import script from "./classDetailY.vue?vue&type=script&lang=js"
export * from "./classDetailY.vue?vue&type=script&lang=js"
import style0 from "./classDetailY.vue?vue&type=style&index=0&id=b6443ff2&prod&lang=less&scoped=true"
import style1 from "./classDetailY.vue?vue&type=style&index=1&id=b6443ff2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6443ff2",
  null
  
)

export default component.exports